import { useNavigate } from "react-router-dom"
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate"
import { TITULO_HORARIO_LIST } from "../../../utils/constantes"
import { HorarioList } from "../../../modules/horario/HorarioList"
import { useEffect, useState } from "react"
import { getAllHorarios } from "../../../services/horario.service"
import { paginacion } from "../../../utils/paginacion/paginacion"
import { ShowButtonsPaginacion } from "../../../utils/paginacion/ShowButtonsPaginacion"

export const HorarioPage = () => {
  const navigate = useNavigate()
  const [horarios, setHorarios] = useState([]);

  useEffect(() => {
    obtenerHorarios()
  }, [])

  const obtenerHorarios = async () => {
    await getAllHorarios().then((horarios) => setHorarios(horarios)).catch((err) => console.log(err))
  }

  const onRegistrarHorario = () => {
    navigate("/horarios/registrar")
  }

  return <ContenedorPageTemplate
    titulo={TITULO_HORARIO_LIST}
    onclick={onRegistrarHorario}
    mostrarBoton={false} // ocultamos el botón aquí
  >
    <HorarioList horarios={horarios} onRefresh={obtenerHorarios} />
  </ContenedorPageTemplate>
}